import { render, staticRenderFns } from "./IndexRejected.vue?vue&type=template&id=19698e8e"
import script from "./IndexRejected.vue?vue&type=script&lang=js"
export * from "./IndexRejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports